import { createSelector } from 'reselect';
import type { ProductFlag } from '../../../../shared/constants/productFlipperFlagRelation';
import type { ProductFlagValues } from '../../../../shared/ProductFlipperFlag.service';
import { ProductFlagService } from '../../../../shared/ProductFlag.service';
import { getFlipperFlagValues } from '../../redux/domains/FlipperUpdates/Flipper.selectors';
import type { ProductSuite } from '../../../../shared/constants/productFlags';
import { PRODUCT_SUITE_FLAGS } from '../../../../shared/constants/productFlags';
import type { RootState } from 'client/js/redux';

function getProductName(state: RootState, productName: ProductFlag): string {
  return productName;
}

function getProductSuite(state: RootState, productSuite: ProductSuite): ProductSuite {
  return productSuite;
}

const EMPTY_OBJECT = {};

export function getProductFlagValues(): ProductFlagValues {
  return (<any>window)?.App?.context?.ppp || EMPTY_OBJECT;
}

export const isProductEnabled: (state: RootState, productName: ProductFlag) => boolean = createSelector(
  getFlipperFlagValues,
  getProductFlagValues,
  getProductName,
  (flipperFlags, productFlags, productName) => {
    return new ProductFlagService().isProductFlagEnabled(productName, productFlags, flipperFlags);
  }
);

export const isProductStrictlyEnabled: (state: RootState, productName: ProductFlag) => boolean = createSelector(
  getProductFlagValues,
  getProductName,
  (productFlags, productName) => {
    return new ProductFlagService().isProductFlagEnabled(productName, productFlags, {});
  }
);

export const hasProductSuite: (state: RootState, productSuite: ProductSuite) => boolean = createSelector(
  getFlipperFlagValues,
  getProductFlagValues,
  getProductSuite,
  (flipperFlags, productFlags, productSuite) => {
    return PRODUCT_SUITE_FLAGS[productSuite].every((product) => {
      return new ProductFlagService().isProductFlagEnabled(product, productFlags, flipperFlags);
    });
  }
);
